import Dexie from 'dexie';
import { TblCatBloque, TblCatChecklist, TblCatEstacion, TblCatEtapaRevision, TblCatMenu, TblCatPregunta, TblCatRespuesta, TblCatRubro, TblCatTipoInput, TblCatTipoRevision, TblCatUsuario, TblRelPreguntaRespuesta, TblRelRevisionChecklist, TblTranBloque, TblTranChecklist, TblTranPregunta, TblTranRespuesta, TblTranRevision, TblTranRubro } from '../types/Tables';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EstacionesTVADB extends Dexie {
  TblCatUsuario: Dexie.Table<TblCatUsuario, number>
  TblCatEtapaRevision: Dexie.Table<TblCatEtapaRevision, number>
  TblCatTipoRevision: Dexie.Table<TblCatTipoRevision, number>
  TblCatEstacion: Dexie.Table<TblCatEstacion, number>
  TblCatChecklist: Dexie.Table<TblCatChecklist, number>
  TblCatBloque: Dexie.Table<TblCatBloque, number>
  TblCatRubro: Dexie.Table<TblCatRubro, number>
  TblCatPregunta: Dexie.Table<TblCatPregunta, number>
  TblCatRespuesta: Dexie.Table<TblCatRespuesta, number>
  TblCatTipoInput: Dexie.Table<TblCatTipoInput, number>
  TblCatMenu: Dexie.Table<TblCatMenu, number>

  TblRelPreguntaRespuesta: Dexie.Table<TblRelPreguntaRespuesta, number>
  TblRelRevisionChecklist: Dexie.Table<TblRelRevisionChecklist, number>
  TblTranRevision: Dexie.Table<TblTranRevision, number>

  TblTranChecklist: Dexie.Table<TblTranChecklist, number>
  TblTranBloque: Dexie.Table<TblTranBloque, number>
  TblTranRubro: Dexie.Table<TblTranRubro, number>
  TblTranPregunta: Dexie.Table<TblTranPregunta, number>
  TblTranRespuesta: Dexie.Table<TblTranRespuesta, number>

  constructor() {
    super("EstacionesTVA");
    this.version(1).stores({
      TblCatUsuario: '&IdEmpleado',
      TblCatEtapaRevision: '&IdEtapa',
      TblCatTipoRevision: '&IdTipoRevision',
      TblCatEstacion: '&IdEstacion',
      TblCatChecklist: '&IdChecklist',
      TblCatBloque: '&IdBloque',
      TblCatRubro: '&IdRubro',
      TblCatPregunta: '&IdPregunta',
      TblCatRespuesta: '&IdRespuesta',
      TblCatTipoInput: '&IdTipoInput',
      TblCatMenu: '&IdMenu',

      TblRelPreguntaRespuesta: '&IdRelacion',
      TblRelRevisionChecklist: '&IdRelacion',

      TblTranRevision: '&IdRevision',
      TblTranChecklist: '&IdChecklist',
      TblTranBloque: '&IdBloque',
      TblTranRubro: '&IdRubro',
      TblTranPregunta: '&IdPregunta',
      TblTranRespuesta: '&IdRelacion'
    });
  }

  GetLocalObject(tableName, key, id) {
    return this[tableName]
      .filter(x => x[key] == id)
      .toArray()
      .then(x => {
        return x[0]
      });
  }

  GetLocalObjectCondition(tableName, expresion) {
    return this[tableName]
      .filter(expresion)
      .toArray()
      .then(x => {
        return x[0]
      });
  }

  GetLocalArray(tableName) {
    return this[tableName].toArray()
      .catch(error => {
        return 'Error in local table [' + tableName + ']';
      });
  }

  postLocalobject(tableName, obj) {
    return this[tableName].add(obj)
      .catch(error => {
        return 'Error in local table [' + tableName + ']';
      });
  }

  putLocalobject(tableName, obj) {
    return this[tableName].put(obj)
      .catch(error => {
        return 'Error in local table [' + tableName + ']';
      });
  }

  postLocalArray(tableName, array) {
    return this[tableName].bulkAdd(array)
      .catch(error => {
        return 'Error in local table [' + tableName + ']';
      });
  }
}
